import { checkParams, zeroUnit, soFarDate } from '../../utils'
import { formatTime, formatDate, formatDatetime } from '../../filter'
import moment from 'moment'

function isTargetPassenger(accidentInfo) {
	// 是否为标的车乘客
	return (
		accidentInfo &&
		accidentInfo.injuryType === '02' &&
		accidentInfo.position === '02'
	)
}

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	//平安初次探视
	let isPAIC = this.isPAIC && this.isFirstVisit
	if (!isPAIC) {
		return false
	}

	let arr = []
	const accidentInfo = injured.accidentInfo || ''

	arr = arr.concat([
		{
			label: '日期',
			key: 'accTime',
			value: accidentInfo.accTime
				? moment(formatTime(accidentInfo.accTime), 'YYYY-MM-DD HH:mm:ss')
				: '',
			type: 'datetime',
			notNull: '1',
			canEdit: true,
			allowClear: false,
			disabledDate: current => {
				// 不能大于今天
				return current && current > moment().endOf('day')
			}, //禁止选择的时间区间
		},
		{
			label: '省',
			key: 'provinceCode',
			value: accidentInfo.provinceCode,
			type: 'hide',
			notNull: '0',
			canEdit: false,
			formSpan: 3,
		},
		{
			label: '市',
			key: 'cityCode',
			value: accidentInfo.cityCode,
			type: 'hide',
			notNull: '0',
			canEdit: false,
			formSpan: 3,
		},
		{
			label: '区',
			key: 'areaCode',
			value: accidentInfo.areaCode,
			type: 'hide',
			notNull: '0',
			canEdit: false,
			formSpan: 3,
		},
		{
			label: '地区',
			key: 'formatAddress',
			value: accidentInfo.formatAddress,
			type: 'searchSelect',
			selectOption: [],
			notNull: '1',
			canEdit: true,
		},
		{
			label: '地点',
			key: 'address',
			value: accidentInfo.address,
			type: 'text',
			notNull: '1',
			canEdit: true,
			rules: [
				{
					max: 50,
					message: '长度不能超过50位',
					trigger: 'blur',
				},
			],
		},
		{
			label: '事故经过',
			key: 'accDesc',
			value: accidentInfo.accDesc,
			type: 'text',
			notNull: '1',
			canEdit: true,
			labelSpan: 2,
			rules: [
				{
					max: 100,
					message: '长度不能超过100位',
					trigger: 'blur',
				},
			],
		},
	])

	const obj = {
		title: '事故经过',
		children: arr,
	}

	return obj
}
